// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3BZFV","header":"ReportDetails_header__3SJU3","title":"ReportDetails_title__LtMBr","left":"ReportDetails_left__PLDQE"};